import React, { useState } from 'react';

import { setAgeVerified } from '../../services/cookieService';

interface AgeVerificationModalProps {
  onVerify: () => void;
}

const AgeVerificationModal: React.FC<AgeVerificationModalProps> = ({ onVerify }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleVerify = () => {
    if (isChecked) {
      setAgeVerified(true);
      onVerify();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-md flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden">
        {/* Modal Header */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 p-4">
          <h2 className="text-xl font-bold text-white text-center">Age Verification Required</h2>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          <div className="mb-6 text-center">
            <svg
              className="w-16 h-16 mx-auto mb-4 text-indigo-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              ></path>
            </svg>
            <p className="text-gray-700 mb-4">
              This website contains content that is only suitable for individuals who are at least
              18 years of age.
            </p>
            <p className="text-gray-700 font-semibold">
              By entering, you confirm that you are at least 18 years old.
            </p>
          </div>

          <div className="mb-6">
            <label className="flex items-center justify-center cursor-pointer">
              <input
                type="checkbox"
                className="form-checkbox h-5 w-5 text-indigo-600 rounded focus:ring-indigo-500"
                checked={isChecked}
                onChange={e => setIsChecked(e.target.checked)}
              />
              <span className="ml-2 text-gray-700">I confirm I am at least 18 years old</span>
            </label>
          </div>

          <div className="flex justify-center">
            <button
              onClick={handleVerify}
              disabled={!isChecked}
              className={`w-full py-3 px-4 rounded-md font-medium text-white transition-colors ${
                isChecked ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-gray-400 cursor-not-allowed'
              }`}
            >
              Enter Website
            </button>
          </div>
        </div>

        {/* Legal Footer */}
        <div className="bg-gray-100 p-4 text-xs text-gray-500 text-center">
          <p>
            By clicking &quot;Enter Website&quot;, you agree to our Terms of Service and Privacy
            Policy. We use cookies to store your age verification status.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerificationModal;
